import React from 'react';
import styles from './index.module.scss';
import { getImageFromS3 } from '../../../imageService';
import { Disclosure } from '@headlessui/react';

const FaqScreen = ({ handleBackButtonClick, setScreenNumber }) => {
  return (
    <div
      className={styles.container}
      style={{
        backgroundImage: `url("${getImageFromS3('images/ua-brand/bg.png')}")`
      }}
    >
      <div className={styles.content}>
        <p className={styles.headTitle}>FAQ</p>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>Що таке Scanpack?</p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                Scanpack – твій інструмент візуального розпізнавання через
                сканування об’єктів. Заходь на Android чи веб-версію, та за
                допомогою камери відкривай нові можливості та контент від
                бренду.
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>Чи потрібен мені Інтернет, щоб використовувати SCANPACK?</p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                Так. Для правильної роботи додатку та отримання бренд-контенту,
                тобі потрібно бути онлайн.
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>Чи потрібна автентифікація для користування SCANPACK?</p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                Ні, автентифікація не потрібна. На платформі ти залишатимешся
                анонімно.
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>Чи можу я скористатись SCANPACK з компʼютера?</p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                Ні, вибач. Створений контент можна проглядати лише на мобільному
                чи планшеті.
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>
                  Як знайти обʼєкти, які можна сканувати за допомогою SCANPACK?
                </p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                Твої улюблені бренди триматимуть тебе в курсі, як і коли можна
                отримати новий контент.
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>
                  Чи можу я сканувати ті ж обʼєкти декілька разів? Що
                  відбудеться?
                </p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                Звичайно! Скануй, скільки заманеться. Тим більше, що деякі
                об’єкти надають різний контент в залежності від числа твоїх
                сканувань.
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>Чи потрібно надати дозвіл до моєї камери?</p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                Для сканування та розпізнавання об'єктів навколо знадобиться
                камера твого пристрою.
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>Чому мені необхідно підтверджувати свій вік?</p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                {'Ми є членами групи Philip Morris International. Веб-сайт і контент, якими ти збираєшся користуватись, призначені лише для повнолітніх курців та/або користувачів пристроїв для споживання тютюнових виробів без їх згоряння.\n\n' +
                  'Щоб отримати доступ, необхідно пройти перевірку віку. Для цього достатньо сфотографувати або завантажити фото: (i) свого обличчя і/або (ii) свого ідентифікаційного документу, якщо нам не вдалося підтвердити вік за допомогою твого особистого фото.\n' +
                  'Це автоматизований процес, щоб переконатись, що ти дорослий/-а. Якщо ти проти перевірки, не завантажуй свої фото чи ідентифікаційний документ та закрий браузер.\n\n' +
                  'Звертаємо твою увагу, що доступність процесу перевірки віку та його детальна послідовність можуть змінюватись в залежності від країни проживання та законодавчих вимог.\n' +
                  'Ми опрацьовуємо персональні дані відповідно до нашої Політики конфіденційності. Також ми використовуємо cookies згідно з нашою політикою.\n\n' +
                  'Підтвердження за допомогою перевірки обличчя\n\n' +
                  'Для цього потрібно завантажити своє особисте фото.\n' +
                  'Будь-ласка, враховуй наступні вимоги:\n' +
                  '   Лише одне обличчя та пара очей на фото (перевір наявність постерів позаду);\n' +
                  '   Зніми окуляри;\n' +
                  '   Не стій напроти вікна;\n' +
                  '   Фото має бути у відповідних якості та розмірах (не надто світле/темне /яскраве, чітке, як мінімум 1000x1000 пікселів);\n' +
                  '   При завантаженні дозволені формати JPG і PNG та розмір до 5MB.\n' +
                  '   Не дозволяється:\n' +
                  '   Просити сторонніх пройти перевірку замість себе;\n' +
                  '   Використовувати чужі фото;\n' +
                  '   Використовувати фото, що належать іншим.'}
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <Disclosure>
          {({ open }) => (
            <>
              <Disclosure.Button
                className={styles.title}
                style={open ? { border: 'none' } : null}
              >
                <p>Все ще залишились питання?</p>
                {open ? (
                  <svg
                    width="12"
                    height="2"
                    viewBox="0 0 12 2"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect
                      y="2"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 2)"
                      fill="#5B2896"
                    />
                  </svg>
                ) : (
                  <svg
                    width="12"
                    height="12"
                    viewBox="0 0 12 12"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                  >
                    <rect x="5" width="2" height="12" fill="#5B2896" />
                    <rect
                      y="7"
                      width="2"
                      height="12"
                      transform="rotate(-90 0 7)"
                      fill="#5B2896"
                    />
                  </svg>
                )}
              </Disclosure.Button>
              <Disclosure.Panel className={styles.text} unmount={false}>
                Просто напиши нам на support.customer@pmi.com
              </Disclosure.Panel>
            </>
          )}
        </Disclosure>
        <div className={styles.buttonContainer}>
          <button onClick={handleBackButtonClick}>Назад</button>
        </div>
      </div>
      <div className={styles.footerContainer}>
        <a href="https://www.pmiprivacy.com/ukraine/uk/consumer/">
          Політика конфіденційності
        </a>
        <button onClick={() => setScreenNumber(2)}>Умови використання</button>
        <button onClick={() => setScreenNumber(3)}>FAQ</button>
        <button onClick={() => setScreenNumber(4)}>
          Параметри застосування файлів cookie
        </button>
      </div>
    </div>
  );
};

export default FaqScreen;
